import React from 'react';

import {
  Avatar as ChakraAvatar,
  AvatarBadge as ChakraAvatarBadge,
  AvatarBadgeProps as ChakraAvatarBadgeProps,
  AvatarGroup as ChakraAvatarGroup,
  AvatarGroupProps as ChakraAvatarGroupProps,
  AvatarProps as ChakraAvatarProps,
} from '@chakra-ui/react';

export interface AvatarProps extends ChakraAvatarProps {
  src?: string;
  alt?: string;
  fallback?: string;
  delayMs?: number;
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ src, alt, fallback, ...props }, ref) => {
    return (
      <ChakraAvatar
        bg='purple.500'
        color='white'
        ref={ref}
        src={src}
        name={alt || fallback}
        {...props}
      />
    );
  }
);

Avatar.displayName = 'Avatar';

// AvatarBadge with proper typing
const AvatarBadge = React.forwardRef<HTMLDivElement, ChakraAvatarBadgeProps>(
  (props, ref) => {
    return <ChakraAvatarBadge ref={ref} {...props} />;
  }
);

AvatarBadge.displayName = 'AvatarBadge';

// AvatarGroup with proper typing
const AvatarGroup = React.forwardRef<HTMLDivElement, ChakraAvatarGroupProps>(
  (props, ref) => {
    return <ChakraAvatarGroup ref={ref} {...props} />;
  }
);

AvatarGroup.displayName = 'AvatarGroup';

// For backward compatibility, export individual components
export const AvatarImage = React.forwardRef<
  HTMLImageElement,
  { src?: string; alt?: string }
>(({ src, alt, ...props }, ref) => (
  <img ref={ref} src={src} alt={alt} {...props} />
));

AvatarImage.displayName = 'AvatarImage';

export const AvatarFallback = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; delayMs?: number }
>(({ children, ...props }, ref) => (
  <div ref={ref} {...props}>
    {children}
  </div>
));

AvatarFallback.displayName = 'AvatarFallback';

export { Avatar, AvatarBadge, AvatarGroup };
